import { defineComponent as _defineComponent } from 'vue'
import AppButton from "@/components/AppButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GifPreview',
  props: {
    image: null
  },
  setup(__props: any) {



return { __sfc: true,AppButton }
}

})